import { Component, Inject } from "@angular/core";
import { Team } from "@common/ADAPT.Common.Model/organisation/team";
import { ADAPT_DIALOG_DATA } from "@common/ux/adapt-common-dialog/adapt-common-dialog.globals";
import { BaseDialogComponent } from "@common/ux/adapt-common-dialog/base-dialog.component/base-dialog.component";

@Component({
    selector: "adapt-activity-feed-dialog",
    standalone: false,
    templateUrl: "./activity-feed-dialog.component.html",
    styleUrl: "./activity-feed-dialog.component.scss",
})
export class ActivityFeedDialogComponent extends BaseDialogComponent<Team> {
    public readonly dialogName = "ActivityFeedDialog";

    public constructor(@Inject(ADAPT_DIALOG_DATA) public team: Team) {
        super();
    }
}
